import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AssignCarsDialog from "../../../Common/AssignCarsDialog";
import {TextField} from "@material-ui/core";
import t from "../../../../languages/pl";
import { InputAdornment,  Typography} from '@material-ui/core';


const ExpectedFuelConsumptionDialog = props => {
    const { open, onClose, onExpectedFuelConsumptionSubmit } = props;
    const [averageCombustion, setAverageCombustion] = useState(0);

    const handleSubmit = (driverIds) => {
        const data = {
            spalanie: averageCombustion,
            lista_aut: driverIds,
        };
        onExpectedFuelConsumptionSubmit(data);
    };

    return (
        <AssignCarsDialog
            title={t.toExpectedFuelConsumption}
            hideImportExportButton
            open={open}
            onClose={onClose}
            onSubmit={handleSubmit}
        >
            <TextField
                //className={classes.textfield}
                label={t.expectedFuelConsumption}
                type="number"
                InputProps={{
                    endAdornment: <InputAdornment position="end"><Typography >l/km</Typography></InputAdornment>
                }}
                value={averageCombustion}
                onChange={(e) => setAverageCombustion(e.target.value)}
            />
        </AssignCarsDialog>
    );
};

ExpectedFuelConsumptionDialog.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onExpectedFuelConsumptionSubmit: PropTypes.func,
    getGroups: PropTypes.func,
};

export default ExpectedFuelConsumptionDialog;
